import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  clientSecret: null,
  customerId: null,
};

const slice = createSlice({
  name: 'checkout',
  initialState,
  reducers: {
    loadClientSecret(state, action) {
      state.clientSecret = action.payload;
    },
    setCustomerId(state, action) {
      state.customerId = action.payload;
    },
    SetSubscriptionId(state, action) {
      state.subscriptionId = action.payload;
    }
  },
});

const checkoutSlice = {
  initialState,
  reducers: {
    [slice.name]: slice.reducer,
  },
  actions: slice.actions,
  select: {
    clientSecret: (state) => state[slice.name].clientSecret,
    customerId: (state) => state[slice.name].customerId,
    subscriptionId: (state) => state[slice.name].subscriptionId,
  },
  rememberedKeys: [slice.name],
};

export default checkoutSlice;

// should I add subscriptionId herer